import gql from "graphql-tag";

export default gql`
	mutation removeSpreadException($user_id: ID, $group_id: ID) {
		removeSpreadException(userId: $user_id, groupId: $group_id) {
			success
		}
	}
`;
